import React from "react";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  UNSAFE_componentWillMount() {
    //this.props.setOriginalAnswers();
  },
  getInitialState() {
    return {
      // isNextButtonDisabled: true
      // showMore: {
      //   51 : false,
      //   52 : false,
      // }
    };
  },
  handleOptionsChange() {
    // 選択式
    const option_elements = document.getElementsByName("options");
    let option_ids = [];
    for (let i = 0; i < option_elements.length; i++) {
      if (option_elements[i].checked) {
        option_ids.push(Number(option_elements[i].value));
      }
    }
    // テキスト
    const text_elements = document.getElementsByName("text");
    const text_answer =
      typeof text_elements[0] !== "undefined" && text_elements[0].length !== 0
        ? text_elements[0].value
        : "";

    this.props.changeFields(this.props.question.id, option_ids, text_answer);
  },
  render() {
    let optionsBox = "";
    const handleOptionsChange = this.handleOptionsChange;
    const answer = this.props.answer;
    if (
      this.props.question.choice_type === 1 ||
      this.props.question.choice_type === 2
    ) {
      optionsBox = this.props.question.questions_options.map((option) => {
        return (
          <li key={option.id} className="nav-item p-3 border-bottom">
            <input
              name="options"
              type={
                this.props.question.choice_type === 1 ? `radio` : `checkbox`
              }
              className="d-none checkbox__input checkbox__area"
              id={`option_${option.id}`}
              onChange={handleOptionsChange}
              value={option.id}
              defaultChecked={
                typeof answer !== "undefined" &&
                answer.length !== 0 &&
                answer.option_answer.includes(option.id)
                  ? true
                  : false
              }
            />
            <label
              className="d-flex justify-content-between align-items-center mb-0 position-relative"
              htmlFor={`option_${option.id}`}
            >
              <span className="p-0 line-height-2 pl-3 mb-0">
                {option.option_wording}
              </span>
              <span className="checkbox__lg checkbox__noborder" />
            </label>
          </li>
        );
      });
      return (
        <div
          className="bg-white h-100"
          style={{
            paddingTop: "30px",
            paddingBottom: "180px",
            borderRadius: "0.25rem",
          }}
        >
          <ul className="nav flex-column">{optionsBox}</ul>
        </div>
      );
    } else if (this.props.question.choice_type === 3) {
      return (
        <textarea
          key={this.props.question.id}
          name="text"
          id={`question_${this.props.question.id}_text`}
          rows="4"
          className="form-control mt-5"
          placeholder="ご入力ください"
          onChange={handleOptionsChange}
          value={
            typeof answer !== "undefined" &&
            typeof answer.text_answer !== "undefined" &&
            this.props.question.id === answer.question_id
              ? answer.text_answer
              : ""
          }
        />
      );
    } else if (
      this.props.question.choice_type === 4 ||
      this.props.question.choice_type === 5
    ) {
      optionsBox = this.props.question.questions_options.map((option) => {
        return (
          <li key={option.id} className="nav-item p-3 border-bottom">
            <input
              name="options"
              type={
                this.props.question.choice_type === 4 ? `radio` : `checkbox`
              }
              className="d-none checkbox__input checkbox__area"
              id={`option_${option.id}`}
              onChange={handleOptionsChange}
              value={option.id}
              defaultChecked={
                typeof answer !== "undefined" &&
                answer.length !== 0 &&
                answer.option_answer.includes(option.id)
                  ? true
                  : false
              }
            />
            <label
              className="d-flex justify-content-between align-items-center mb-0 position-relative"
              htmlFor={`option_${option.id}`}
            >
              <span className="p-0 line-height-2 pl-3 mb-0">
                {option.option_wording}
              </span>
              <span className="checkbox__lg checkbox__noborder" />
            </label>
          </li>
        );
      });
      return (
        <div>
          <div
            className="bg-white h-100"
            style={{
              paddingTop: "30px",
              paddingBottom: "180px",
              borderRadius: "0.25rem",
            }}
          >
            <ul className="nav flex-column">
              {optionsBox}
              <li className="nav-item p-3 border-bottom">
                <span className="p-0 line-height-2 pl-3 mb-0">その他</span>
                <textarea
                  key={this.props.question.id}
                  name="text"
                  id={`question_${this.props.question.id}_text`}
                  rows="4"
                  className="form-control mt-1"
                  placeholder="ご入力ください"
                  onChange={handleOptionsChange}
                  value={
                    typeof answer !== "undefined" &&
                    typeof answer.text_answer !== "undefined" &&
                    this.props.question.id === answer.question_id
                      ? answer.text_answer
                      : ""
                  }
                />
              </li>
            </ul>
          </div>
        </div>
      );
    }
  },
});
